import { useState } from 'react'
import { Box, Button, Container, Grid, Link, TextField, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from "react-router-dom"
import { useUserContext } from 'strview-common'

const ForgotPasswordStepTwoForm = () => {
  const { user, confirmPassword } = useUserContext()
  const navigate = useNavigate()
  const [errorMessage, setErrorMessage] = useState("")

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const data = {
      email: user.email,
      verificationCode: formData.get("verification-code"),
      newPassword: formData.get("new-password"),
    }
    const confirmPasswordResult = await confirmPassword(data)

    if (confirmPasswordResult.success) {
      navigate("/login")
    } else {
      setErrorMessage(confirmPasswordResult.errorMessage)
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          Forgot Password Step Two
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            disabled
            fullWidth
            id="email"
            name="email"
            value={user.email}

          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="verification-code"
            label="Verification Code"
            type="text"
            id="verification-code"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="new-password"
            label="New Password"
            type="password"
            id="new-password"
            autoComplete="new-password"

          />
          <Typography sx={{ "color": "red" }} >
            {errorMessage}
          </Typography>
          {/* <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              /> */}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>
          <Grid container>
            {/* <Grid item xs>
                  <Link href="#" variant="body2">
                    Forgot password?
                  </Link>
                </Grid> */}
            <Grid item>
              <Link href="/login" variant="body2">
                {"Login"}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  )
}

export default ForgotPasswordStepTwoForm